/**
 * WATERMARK OVERLAY
 * 
 * Displays a semi-transparent watermark over images for trial listings.
 * The watermark is rendered as an overlay that cannot be easily removed.
 */

import React from 'react';
import { cn } from '@/lib/utils';

interface WatermarkOverlayProps {
  children: React.ReactNode;
  className?: string;
  watermarkText?: string;
}

export function WatermarkOverlay({ 
  children, 
  className,
  watermarkText = "TRIAL • ListBright"
}: WatermarkOverlayProps) {
  return (
    <div className={cn("relative overflow-hidden", className)}>
      {children}
      
      {/* Watermark overlay - multiple instances for coverage */}
      <div 
        className="absolute inset-0 pointer-events-none select-none overflow-hidden"
        style={{ zIndex: 10 }}
      >
        {/* Diagonal watermark pattern */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div 
            className="absolute"
            style={{
              transform: 'rotate(-30deg)',
              whiteSpace: 'nowrap',
            }}
          >
            {/* Create a grid of watermarks */}
            <div className="flex flex-col gap-16 opacity-40">
              {[...Array(5)].map((_, rowIdx) => (
                <div key={rowIdx} className="flex gap-24">
                  {[...Array(4)].map((_, colIdx) => (
                    <span 
                      key={colIdx}
                      className="text-white font-bold text-lg tracking-wider drop-shadow-lg"
                      style={{
                        textShadow: '2px 2px 4px rgba(0,0,0,0.5), -1px -1px 2px rgba(0,0,0,0.3)',
                      }}
                    >
                      {watermarkText}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
        
        {/* Corner badge */}
        <div className="absolute bottom-2 right-2 bg-primary/90 text-primary-foreground px-2 py-1 rounded text-xs font-semibold shadow-lg">
          Trial Version
        </div>
      </div>
    </div>
  );
}
